import { createFileRoute } from "@tanstack/react-router";
import { SessionPaymentResult } from "@/components/booking/SessionPaymentResult";
import { legacySessionSearch } from "@/lib/payment-return-url";

// Legacy Monri return URL (`?status=..&session=..&token=..`), kept for payment
// forms opened before the path-based URLs. Monri glues its own params onto the
// last of ours with a second `?`; legacySessionSearch cuts them off.
export const Route = createFileRoute("/booking/payment-result")({
  validateSearch: (search: Record<string, unknown>) => legacySessionSearch(search),
  component: LegacySessionPaymentResult,
});

function LegacySessionPaymentResult() {
  return <SessionPaymentResult {...Route.useSearch()} />;
}
